import { ArrowMediumDown32, ArrowMediumUp32 } from '@packages/themes/icons';
import React from 'react';
import { useIntl } from 'react-intl';
import { CardHeader, Typography } from '@packages/shared';
import { engravingInputMessages } from './messages';

interface ShowMoreInformationLinkProps {
  showMoreInformation: boolean;
  moreInformationHandler: () => void;
}

export const ShowMoreInformationLink = ({
  showMoreInformation,
  moreInformationHandler,
}: ShowMoreInformationLinkProps): React.ReactElement => {
  const format = useIntl().formatMessage;

  return (
    <CardHeader
      title={
        <Typography variant="body2">
          {showMoreInformation
            ? format(engravingInputMessages.moreInformationLinkClose)
            : format(engravingInputMessages.moreInformationLink)}
        </Typography>
      }
      action={
        showMoreInformation ? (
          <ArrowMediumUp32 sx={{ display: 'block' }} />
        ) : (
          <ArrowMediumDown32 sx={{ display: 'block' }} />
        )
      }
      sx={{ cursor: 'pointer' }}
      onClick={() => moreInformationHandler()}
    />
  );
};
